import { render } from "./PanelAdminImportManual.vue?vue&type=template&id=0d4252c0&ts=true"
import script from "./PanelAdminImportManual.vue?vue&type=script&lang=ts"
export * from "./PanelAdminImportManual.vue?vue&type=script&lang=ts"

import "./PanelAdminImportManual.vue?vue&type=style&index=0&id=0d4252c0&lang=scss"

import exportComponent from "/home/administrator/tourstat-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__